const DEFAULT_MAX_RECRUITMENT_FLOW_STEPS = 15;

export const DEFAULT_METADATA = {
    anonymous_fields: {},
    step_types: {},
    languages: [],
    max_recruitment_flow_steps: DEFAULT_MAX_RECRUITMENT_FLOW_STEPS,
    can_create_recruitment_flow_steps: false,
    can_choose_application_locking_step: false,
};

export const mapRecruitmentFlowStepsMeta = (data, t) => {
    const mappedData =  {
        steps: data.steps || [],
        step_types: data.step_types || {},
        max_recruitment_flow_steps: data.max_recruitment_flow_steps || DEFAULT_MAX_RECRUITMENT_FLOW_STEPS,
        can_create_recruitment_flow_steps: Boolean(data.can_create_recruitment_flow_steps),
        can_choose_application_locking_step: Boolean(data.can_choose_application_locking_step),
    };
    if (data.anonymous_fields) {
        mappedData.anonymous_fields = data.anonymous_fields || {};
    }

    if (data.languages) {
        mappedData.languages = [
            { name: t('Default'), code: 'default' },
            ...data.languages.map(({ id: code, name }) => ({ name, code })),
        ];
    }
    return mappedData;
};